import { motion } from "framer-motion";
import { Gauge, ShieldCheck, Smartphone, Zap, BarChart3 } from "lucide-react";

const items = [
  { icon: Gauge, label: "Conversion-Focused Websites" },
  { icon: ShieldCheck, label: "SEO-Ready Structure" },
  { icon: Smartphone, label: "Mobile-First Design" },
  { icon: Zap, label: "Fast Loading Pages" },
  { icon: BarChart3, label: "Analytics-Driven Growth" },
];

export default function TrustBar() {
  return (
    <section data-testid="trust-bar" className="relative py-14 border-y border-white/[0.06]">
      <div className="container-apex">
        <p className="text-center text-xs uppercase tracking-[0.32em] text-white/50 mb-8">
          Every APEX site ships with
        </p>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.label}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className="glass glass-hover px-4 py-4 flex items-center gap-3"
                data-testid={`trust-item-${i}`}
              >
                <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-apex-cyan/10 border border-apex-cyan/25">
                  <Icon className="w-4 h-4 text-apex-cyan" strokeWidth={1.75} />
                </span>
                <span className="text-sm font-medium text-white/85 leading-tight">{it.label}</span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
